export enum AddTradesOnboardingSubcaseEnum {
    start = 'start',
    import = 'import',
    manual = 'manual',
}
